import styles from './Users.module.css';
import Button from '../../../components/Button/Button';
import Input from '../../../components/Input/Input';
import {CustomSelect} from '../../../components/Select/Select';
import {
	getAllDivisionsUrl,
	getAllInstructionsUrl,
	getAllProfessionsUrl,
	getAllUsersPaginatedUrl
} from '../../../helpers/constants';
import React, {useEffect, useState} from 'react';
import UniversalTable from '../../../components/UTable/UTable';
import {Modal} from '../../../components/Modals/Modal';
import {DeleteUser} from '../../../components/Modals/DeleteUser/DeleteUser';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import {CreateUser} from '../../../components/Modals/CreateUser/CreateUser';
import {ManageProf} from '../../../components/Modals/ManageProf/ManageProf';
import {ManageDiv} from '../../../components/Modals/ManageDiv/ManageDiv';
import {BindModal} from '../../../components/Modals/BindModal/BindModal';
import {UploadUsers} from '../../../components/Modals/UploadUsers/UploadUsers';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';
import {getColumns} from './table_columns';
import {SurfaceBar} from '../../../components/SurfaceBar/SurfaceBar';


export function Users () {
	const [selectedProfOption, setSelectedProfOption] = useState(null);
	const [selectedDivOption, setSelectedDivOption] = useState(null);
	const [lastNameFilter, setLastNameFilter] = useState(undefined);
	const [isCreateModalOpen, setCreateModalOpen] = useState(false);
	const [isManageProfModalOpen, setManageProfModalOpen] = useState(false);
	const [isManageDivModalOpen, setManageDivModalOpen] = useState(false);
	const [isBindModalOpen, setBindModalOpen] = useState(false);
	const [isUploadModalOpen, setUploadModalOpen] = useState(false);
	const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
	const [selectedUser, setSelectedUser] = useState(null);
	const [totalRecords, setTotalRecords] = useState(0);
	const [refreshKey, setRefreshKey] = useState(0);
	const [errorApi, setErrorApi] = useState(undefined);

	const {
		error: errorProf,
		options: optionsProf,
		itemDict: professionDict,
		getItems: getProfessions
	} = useFillSelect({
		endpoint: getAllProfessionsUrl,
		labelField: 'title'
	});

	const {
		error: errorDiv,
		options: optionsDiv,
		itemDict: divisionDict,
		getItems: getDivisions
	} = useFillSelect({
		endpoint: getAllDivisionsUrl,
		labelField: 'title'
	});

	const {
		error: errorIns,
		options: optionsIns,
		itemDict: instructionDict,
		getItems: getInstructions
	} = useFillSelect({
		endpoint: getAllInstructionsUrl,
		labelField: 'title'
	});

	useEffect(() => {
		setErrorApi(errorProf || errorDiv || errorIns);
	}, [errorProf, errorDiv, errorIns]);

	const ClearFilters = () => {
		setSelectedProfOption(null);
		setSelectedDivOption(null);
		setLastNameFilter('');
	};

	const [debouncedLastName, setDebouncedLastName] = useState(lastNameFilter);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedLastName(lastNameFilter);
		}, 500);

		return () => clearTimeout(timer);
	}, [lastNameFilter]);


	let filters = {};
	if (lastNameFilter) {
		filters = {
			...filters,
			last_name__ilike: `%${debouncedLastName}%`
		};
	}
	if (selectedProfOption) {
		filters = {
			...filters,
			profession_id__in: selectedProfOption.value
		};
	}
	if (selectedDivOption) {
		filters = {
			...filters,
			division_id__in: selectedDivOption.value
		};
	}

	const openCreateModal = () => {
		setSelectedUser(null);
		setCreateModalOpen(true);
	};

	const columns = getColumns(
		professionDict,
		divisionDict,
		setSelectedUser,
		setCreateModalOpen,
		setDeleteModalOpen,
		styles
	);

	const managementActions = (
		<>
			<Button onClick={openCreateModal}>
				Добавить сотрудника
			</Button>
			<Button onClick={() => setUploadModalOpen(true)}>
				Загрузить из файла
			</Button>
			<Modal isOpen={isUploadModalOpen} onClose={() => setUploadModalOpen(false)}>
				<UploadUsers
					setModalOpen={setUploadModalOpen}
					setRefreshKey={setRefreshKey}
				/>
			</Modal>
			<Modal isOpen={isCreateModalOpen} onClose={() => setCreateModalOpen(false)}>
				<CreateUser
					optionsProf={optionsProf}
					optionsDiv={optionsDiv}
					setCreateModalOpen={setCreateModalOpen}
					setRefreshKey={setRefreshKey}
					setLastNameFilter={setLastNameFilter}
					currentUser={selectedUser}
				/>
			</Modal>
			<Button onClick={() => setManageProfModalOpen(true)}>
				Профессии
			</Button>
			<Modal isOpen={isManageProfModalOpen} onClose={() => setManageProfModalOpen(false)}>
				<ManageProf
					optionsProf={optionsProf}
					getProfessions={getProfessions}
					optionsIns={optionsIns}
					instructionDict={instructionDict}
				/>
			</Modal>
			<Button onClick={() => setManageDivModalOpen(true)}>
				Подразделения
			</Button>
			<Modal isOpen={isManageDivModalOpen} onClose={() => setManageDivModalOpen(false)}>
				<ManageDiv
					optionsDiv={optionsDiv}
					divisionDict={divisionDict}
					getDivisions={getDivisions}
				/>
			</Modal>
			<Button onClick={() => setBindModalOpen(true)}>
				Привязки
			</Button>
			<Modal wide isOpen={isBindModalOpen} onClose={() => setBindModalOpen(false)}>
				<BindModal
					professions={Object.values(professionDict)}
					instructions={Object.values(instructionDict)}
				/>
			</Modal>
		</>
	);

	return (
		<div className={styles.users}>
			<SurfaceBar actions={managementActions} />

			<div className={styles.outer_table}>
				<h2 className={styles.section_title}>Список сотрудников</h2>
				<ErrorMessage
					error={errorApi}
					onClose={() => setErrorApi(undefined)}
				/>
				<div className={styles.table_toolbar}>
					<div className={styles.filters_table}>
						<Input
							value={lastNameFilter}
							 onChange={(e) => setLastNameFilter(e.target.value)}
							placeholder="Поиск по фамилии"
						/>
						<CustomSelect
							value={selectedProfOption}
							options={optionsProf}
							placeholder="Профессия"
							onChange={setSelectedProfOption}
						>
						</CustomSelect>
						<CustomSelect
							value={selectedDivOption}
							options={optionsDiv}
							placeholder="Подразделение"
							onChange={setSelectedDivOption}
						>
						</CustomSelect>
						<buton className={styles.filter_button} onClick={ClearFilters}>
							<img  src="/icons/drop-filters-icon.svg" alt="drop-filters"/>
						</buton>
					</div>
					<div className={styles.table_count}>
						Записей: {totalRecords}
					</div>
				</div>
				<div className={styles.table}>
					<UniversalTable
						endpoint={getAllUsersPaginatedUrl}
						columns={columns}
						usePagination={true}
						initialPage={1}
						initialPageSize={10}
						filters={filters}
						onTotalRecordsChange={setTotalRecords}
						refreshKey={refreshKey}
					/>
				</div>
			</div>
			<Modal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
				<DeleteUser
					user={selectedUser}
					setDeleteModalOpen={setDeleteModalOpen}
					setRefreshKey={setRefreshKey}
					setLastNameFilter={setLastNameFilter}
				/>
			</Modal>
		</div>
	);
}